import React from "react";

import PropTypes from "prop-types";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ProgressiveImage } from "./Image";
import { isMobile } from "../userAgentDetect";

const CarouselShowcase = ({ images }) => (
  <Carousel
    showArrows={false}
    showThumbs={false}
    showStatus={false}
    infiniteLoop
    autoPlay
    showIndicators={isMobile}
  >
    {images.map(({ label, id, bgColor }, idx) => (
      <ProgressiveImage
        imgSmall={
          idx > 2
            ? null
            : `https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_27/v1536237568/mondaybee/assets/${id}`
        }
        imgLarge={`https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto:low/l_mondaybee:assets:watermark,x_400,y_330/v1536237568/mondaybee/assets/${id}`}
        alt={label}
        backgroundColor={bgColor}
        paddingBottom={`${
          isMobile ? Math.max(window.innerHeight - 300, 250) : 400
        }px`}
        key={id}
      />
    ))}
  </Carousel>
);

CarouselShowcase.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      bgColor: PropTypes.string
    })
  ).isRequired
};

export default CarouselShowcase;



// WEBPACK FOOTER //
// ./src/components/ProgressiveCarousel.js